module.exports = __webpack_public_path__ + "static/adineuePRO-BlackWeb-3d03df6afb9b70d6afa25314344819f5.woff";